import { combineReducers } from '@reduxjs/toolkit';

import { ettersendingReducer, EttersendingState } from '../ettersending/reducer/ettersending-reducer';
import { klageReducer, KlageState } from '../klage/reducer/klage-reducer';
import { skademeldingReducer, SkademeldingState } from '../meldskade/reducer/skademelding-reducer';
import {
    skademeldingOppsummeringReducer,
    SkademeldingOppsummeringState,
} from '../meldskade/reducer/skademeldingOppsummering-reducer';

export interface AppState {
    ettersending: EttersendingState;
    skademelding: SkademeldingState;
    skademeldingOppsummering: SkademeldingOppsummeringState;
    klage: KlageState;
}

const rootReducer = combineReducers({
    ettersending: ettersendingReducer,
    skademelding: skademeldingReducer,
    skademeldingOppsummering: skademeldingOppsummeringReducer,
    klage: klageReducer,
});

export default rootReducer;
